import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import modal from '../../css/style.module.css';
import { getApi, postApi, putApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import { useCallback, useEffect, useRef, useState } from 'react';
import { IoClose, IoCloudUploadSharp } from 'react-icons/io5';
import { RiCloseLargeFill } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import img from '../../assest/img12.png';

const SuccessfullyModal = props => {
  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body style={{ padding: '30px' }}>
        <div className={modal.modelsuccessfully}>
          <img src={img} alt="" />
          <p>{props.text}</p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const DeleteSuccessfullyModal = props => {
  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body style={{ padding: '30px' }}>
        <div className={modal.modelsuccessfullyclose}>
          <IoClose color="#000000" size={25} onClick={props.handleClose} />
        </div>
        <div className={modal.modelsuccessfullydelete}>
          <p>
            Are You Really Wanted to
            <br /> {props.text} ??
          </p>
          <div className={modal.modelsuccessfullybuttons}>
            <button onClick={props.handleClose}>No</button>
            <button onClick={props.handleConfirm} style={{ background: '#5A5A5A' }}>
              Yes
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export const OrderCancelModal = props => {
  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body style={{ padding: '30px' }}>
        <div className={modal.modelsuccessfullyclose}>
          <IoClose color="#000000" size={25} onClick={props.handleClose} />
        </div>
        <div className={modal.modelsuccessfullydelete}>
          <p>
            Are You Really Wanted to
            <br /> {props.text} ??
          </p>
          <div className={modal.modelsuccessfullybuttons}>
            <button onClick={props.handleClose}>No</button>
            <button onClick={props.handleConfirm} style={{ background: '#5A5A5A' }}>
              Yes
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const ViewStaffProfile = props => {
  const { data, onHide } = props;
  const [loading, setLoading] = useState(false);

  const [imagePreviews, setImagePreviews] = useState({
    aadharCard: '',
    aadharCardBack: '',
    panCard: '',
    addressProof: '',
    tenthMarkSheet: '',
    twelfthMarkSheet: '',
    graduationMarkSheet: '',
    postGraduationMarkSheet: '',
    policeVerification: '',
  });

  const fetchStaffData = useCallback(async () => {
    await getApi(endPoints.getStaffbyid(data?._id), {
      setResponse: response => {
        const docunent = response?.docunent || {};
        setImagePreviews({
          aadharCard: docunent?.aadharCard || '',
          aadharCardBack: docunent?.aadharCardBack || '',
          panCard: docunent?.panCard || '',
          addressProof: docunent?.addressProof || '',
          tenthMarkSheet: docunent?.tenthMarkSheet || '',
          twelfthMarkSheet: docunent?.twelfthMarkSheet || '',
          graduationMarkSheet: docunent?.graduationMarkSheet || '',
          postGraduationMarkSheet: docunent?.postGraduationMarkSheet || '',
          policeVerification: docunent?.policeVerification || '',
        });
      },
      setLoading,
      errorMsg: 'Failed to fetch data!',
    });
  }, [data]);

  useEffect(() => {
    fetchStaffData();
  }, [fetchStaffData]);

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body style={{ padding: '30px' }}>
        <div className={modal.modelsuccessfullyclose}>
          <RiCloseLargeFill color="#000000" size={25} onClick={onHide} />
        </div>
        <div className={modal.modeluserprofile}>
          <div className={modal.modeluserprofilecontainer}>
            <h6>Staff Details</h6>
            <div className={modal.adduserleftdetails}>
              <div className={modal.adduserleftprofileimage}>
                <img src={data?.image} alt={data?.firstName} />
              </div>
              <div className={modal.adduserleftuserdetails}>
                <div className={modal.adduserleftuser}>
                  <p>Name</p>
                  <span>:</span>
                  <p>
                    {data?.firstName} {data?.lastName}
                  </p>
                </div>
                <div className={modal.adduserleftuser}>
                  <p>Email</p>
                  <span>:</span>
                  <p>{data?.email}</p>
                </div>
                <div className={modal.adduserleftuser}>
                  <p>Number</p>
                  <span>:</span>
                  <p>+91{data?.phone}</p>
                </div>
                <div className={modal.adduserleftuser}>
                  <p>Gender</p>
                  <span>:</span>
                  <p>{data?.gender}</p>
                </div>
                {/* <div className={modal.adduserleftuser}>
                                    <p>Role</p>
                                    <span>:</span>
                                    <ul>
                                        {
                                            data?.role?.length === 0 ?
                                                <option value="">No Role</option>
                                                :
                                                data?.role?.map((cat) => (
                                                    <li>{cat}</li>
                                                ))}
                                    </ul>
                                </div> */}
                <div className={modal.adduserleftuser}>
                  <p>Jobs Role</p>
                  <span>:</span>
                  {/* <p>{data?.role ? data?.role : 'N/A'}</p> */}
                  <ul>
                    {data?.subcategoryId?.length === 0 ? (
                      <option value="">No Jobs type</option>
                    ) : (
                      data?.subcategoryId?.map(cat => <li>{cat?.name}</li>)
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <h6>Documents</h6>
            <div className={modal.adduserrighttdocumentdetails}>
              <div className={modal.adduserrightdocumentimage}>
                <div className={modal.adduserrightdocument}>
                  {imagePreviews?.aadharCard ? (
                    <>
                      <a href={imagePreviews.aadharCard} target="_blank" rel="noreferrer">
                        <img src={imagePreviews.aadharCard} alt="Aadhar Card" />
                      </a>
                      <a href={imagePreviews.aadharCard} download target="_blank" rel="noreferrer">
                        <span style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                          ⬇ Download
                        </span>
                      </a>
                    </>
                  ) : (
                    <p>No File</p>
                  )}
                </div>

                <div className={modal.adduserrightdocument}>
                  {imagePreviews?.aadharCardBack ? (
                    <>
                      <a href={imagePreviews.aadharCardBack} target="_blank" rel="noreferrer">
                        <img src={imagePreviews.aadharCardBack} alt="Aadhar Card Back" />
                      </a>
                      <a href={imagePreviews.aadharCardBack} download target="_blank" rel="noreferrer">
                        <span style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                          ⬇ Download
                        </span>
                      </a>
                    </>
                  ) : (
                    <p>No File</p>
                  )}
                </div>

                <div className={modal.adduserrightdocument}>
                  {imagePreviews?.panCard ? (
                    <>
                      <a href={imagePreviews.panCard} target="_blank" rel="noreferrer">
                        <img src={imagePreviews.panCard} alt="PAN Card" />
                      </a>
                      <a href={imagePreviews.panCard} download target="_blank" rel="noreferrer">
                        <span style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                          ⬇ Download
                        </span>
                      </a>
                    </>
                  ) : (
                    <p>No File</p>
                  )}
                </div>

                <div className={modal.adduserrightdocument}>
                  {imagePreviews?.addressProof ? (
                    <>
                      <a href={imagePreviews.addressProof} target="_blank" rel="noreferrer">
                        <img src={imagePreviews.addressProof} alt="Address Proof" />
                      </a>
                      <a
                        href={imagePreviews.addressProof}
                        download
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                          ⬇ Download
                        </span>
                      </a>
                    </>
                  ) : (
                    <p>No File</p>
                  )}
                </div>

                <div className={modal.adduserrightdocument}>
                  {imagePreviews?.tenthMarkSheet ? (
                    <>
                      <a href={imagePreviews.tenthMarkSheet} target="_blank" rel="noreferrer">
                        <img src={imagePreviews.tenthMarkSheet} alt="10th Marksheet" />
                      </a>
                      <a
                        href={imagePreviews.tenthMarkSheet}
                        download
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                          ⬇ Download
                        </span>
                      </a>
                    </>
                  ) : (
                    <p>No File</p>
                  )}
                </div>

                <div className={modal.adduserrightdocument}>
                  {imagePreviews?.twelfthMarkSheet ? (
                    <>
                      <a href={imagePreviews.twelfthMarkSheet} target="_blank" rel="noreferrer">
                        <img src={imagePreviews.twelfthMarkSheet} alt="12th Marksheet" />
                      </a>
                      <a
                        href={imagePreviews.twelfthMarkSheet}
                        download
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                          ⬇ Download
                        </span>
                      </a>
                    </>
                  ) : (
                    <p>No File</p>
                  )}
                </div>

                <div className={modal.adduserrightdocument}>
                  {imagePreviews?.graduationMarkSheet ? (
                    <>
                      <a href={imagePreviews.graduationMarkSheet} target="_blank" rel="noreferrer">
                        <img src={imagePreviews.graduationMarkSheet} alt="Graduation Marksheet" />
                      </a>
                      <a
                        href={imagePreviews.graduationMarkSheet}
                        download
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                          ⬇ Download
                        </span>
                      </a>
                    </>
                  ) : (
                    <p>No File</p>
                  )}
                </div>

                <div className={modal.adduserrightdocument}>
                  {imagePreviews?.postGraduationMarkSheet ? (
                    <>
                      <a
                        href={imagePreviews.postGraduationMarkSheet}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={imagePreviews.postGraduationMarkSheet}
                          alt="Post Graduation Marksheet"
                        />
                      </a>
                      <a
                        href={imagePreviews.postGraduationMarkSheet}
                        download
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                          ⬇ Download
                        </span>
                      </a>
                    </>
                  ) : (
                    <p>No File</p>
                  )}
                </div>

                <div className={modal.adduserrightdocument}>
                  {imagePreviews?.policeVerification ? (
                    <>
                      <a href={imagePreviews.policeVerification} target="_blank" rel="noreferrer">
                        <img src={imagePreviews.policeVerification} alt="Police Verification" />
                      </a>
                      <a
                        href={imagePreviews.policeVerification}
                        download
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                          ⬇ Download
                        </span>
                      </a>
                    </>
                  ) : (
                    <p>No File</p>
                  )}
                </div>
              </div>

              <div className={modal.adduserleftuserdetails}>
                <div className={modal.adduserleftuser}>
                  <p>Description</p>
                  <span>:</span>
                  <h5>{data?.description || 'N/A'}</h5>
                </div>
                <div className={modal.adduserleftuser}>
                  <p>Status</p>
                  <span>:</span>
                  <p>{data?.status || 'N/A'}</p>
                </div>
              </div>
            </div>
          </div>
          <div className={modal.modeluserprofilebutton}>
            <Link to={`/staff-management/registered/staffprofile/${data?._id}`}>
              <button>View More</button>
            </Link>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const DownloadModal = props => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const handleDownload = () => {
    props.handleDownload(fromDate, toDate);

    // Clear input fields after submit
    setFromDate('');
    setToDate('');
  };

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className={modal.modaldownload}>
          <div className={modal.modaldownloadheading}>
            <h6>Select Dates To Download Payments</h6>
            <IoClose color="#000000" size={25} onClick={props.handleClose} />
          </div>
          {/* <div className={modal.modaldownloadboxconatiner}>
                        <div className={modal.modaldownloadbox}>
                            <h5>Total Amount</h5>
                            <p>₹50,000</p>
                        </div>
                        <div className={modal.modaldownloadbox}>
                            <h5>GST Paid</h5>
                            <p>₹6,000</p>
                        </div>
                        <div className={modal.modaldownloadbox}>
                            <h5>SGST Paid</h5>
                            <p>₹4,000</p>
                        </div>
                        <div className={modal.modaldownloadbox}>
                            <h5>IGST Paid</h5>
                            <p>₹2,000</p>
                        </div>
                    </div> */}
          <div className={modal.modaldownloadinputconatiner}>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="">Start Date *</label>
              <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="">End Date*</label>
              <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} />
            </div>
          </div>
          <div className={modal.modaldownloadbutton}>
            <button disabled={props.loading} onClick={handleDownload}>
              {props.loading ? 'Downloading' : 'Download'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const DownloadTimesheetModal = props => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const handleDownload = () => {
    props.handleDownload(fromDate, toDate);

    // Clear input fields after submit
    setFromDate('');
    setToDate('');
  };

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className={modal.modaldownload}>
          <div className={modal.modaldownloadheading}>
            <h6>Select Dates To Download Timesheet ??</h6>
            <IoClose color="#000000" size={25} onClick={props.handleClose} />
          </div>
          <div className={modal.modaldownloadinputconatiner}>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="">Start Date *</label>
              <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="">End Date*</label>
              <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} />
            </div>
          </div>
          <div className={modal.modaldownloadbutton}>
            <button disabled={props.loading} onClick={handleDownload}>
              {props.loading ? 'Downloading' : 'Download'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const AddCategory = props => {
  const { data, edit, Category, onHide } = props;
  const id = data?._id;
  const [name, setName] = useState(data?.name || '');
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(data?.image || null);

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (edit && data) {
      setName(data.name || '');
      setImage(null);
      setImagePreview(data.image || null);
    } else {
      resetForm();
    }
  }, [edit, data]);

  // Reset form inputs
  const resetForm = () => {
    setName('');
    setImage(null);
    setImagePreview('');
  };

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };
  const handleUploadClick = () => fileInputRef.current?.click();

  const handleSubmit = async () => {
    if (!name || !image) {
      toast.error('Please provide both name and image!');
      return;
    }
    const formData = new FormData();
    formData.append('name', name);
    formData.append('image', image);

    await postApi(endPoints.addcategory, formData, {
      setLoading,
      successMsg: 'Category added successfully!',
      errorMsg: 'Failed to add category!',
    });
    Category();
    onHide();
    resetForm();
  };
  const handleUpdate = async () => {
    if (!name) {
      toast.error('Please provide a name!');
      return;
    }
    const formData = new FormData();
    formData.append('name', name);
    if (image) formData.append('image', image);

    await putApi(endPoints.updatecategory(id), formData, {
      setLoading,
      successMsg: 'Category updated successfully!',
      errorMsg: 'Failed to update category!',
    });
    Category();
    onHide();
    resetForm();
  };

  const closeModal = () => {
    resetForm();
    onHide();
  };

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className={modal.modaldownload}>
          <div className={modal.modaldownloadheading}>
            <h6>{edit ? 'Edit Category' : 'Add Category'}</h6>
            <IoClose size={25} onClick={closeModal} />
          </div>
          <div className={modal.modaldownloadinputconatiner}>
            <div className={modal.modaldownloadinput}>
              <label>Name</label>
              <input type="text" value={name} onChange={e => setName(e.target.value)} />
            </div>
            <div className={modal.modaldownloadinput}>
              <label>Image</label>
              <div className={modal.modalupload} onClick={handleUploadClick}>
                <IoCloudUploadSharp />
                <p>Upload an Image</p>
              </div>
              <input type="file" ref={fileInputRef} onChange={handleFileChange} hidden />
              {imagePreview && (
                <img src={imagePreview} alt="Preview" className={modal.imagePreview} />
              )}
            </div>
          </div>
          <div className={modal.modaldownloadbutton}>
            <button onClick={edit ? handleUpdate : handleSubmit} disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const AddSubCategory = props => {
  const { data, edit, SubCategory, onHide } = props;
  const id = data?._id;

  const [name, setName] = useState(data?.name || '');
  const [categoryId, setCategoryId] = useState(data?.categoryId?._id || null);
  const [categoryname, setCategoryname] = useState(data?.categoryId?.name || null);
  const [isproduct, setIsProduct] = useState(data?.isProduct || false);
  const [approvalRequired, setApprovalRequired] = useState(data?.approval_required || false);
  const [image, setImage] = useState(data?.image || null);
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(data?.image || null);

  const [categoryData, setCategoryData] = useState([]);

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (edit && data) {
      setName(data?.name || '');
      setCategoryId(data?.categoryId?._id || null);
      setCategoryname(data?.categoryId?.name || '');
      setIsProduct(data?.isProduct || false);
      setApprovalRequired(data?.approval_required || false);
      setImage(null);
      setImagePreview(data?.image || null);
    } else if (!edit) {
      resetForm();
    }
  }, [edit, data]);

  // Reset form inputs
  const resetForm = () => {
    setName('');
    setCategoryId(null); // Reset to null for consistency
    setCategoryname('');
    setIsProduct(false); // Reset to false
    setApprovalRequired(false);
    setImage(null);
    setImagePreview('');
  };

  const handleFileChange = event => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };
  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleSubmit = async () => {
    if (!name || !categoryId || !image) {
      toast.error('Please provide all the fields!');
      return;
    }

    const formData = new FormData();
    formData.append('name', name);
    formData.append('categoryId', categoryId);
    formData.append('isProduct', isproduct);
    formData.append('approval_required', approvalRequired);
    formData.append('image', image);

    await postApi(endPoints.addsubcategory, formData, {
      setLoading,
      successMsg: 'SubCategory added successfully!',
      errorMsg: 'Failed to add subcategory!',
    });
    SubCategory();
    onHide();
    resetForm();
  };
  const handleupdate = async () => {
    if (!name || !categoryId) {
      toast.error('Please provide all the required fields!');
      return;
    }
    const formData = new FormData();
    formData.append('name', name);
    formData.append('categoryId', categoryId);
    formData.append('isProduct', isproduct);
    formData.append('approval_required', approvalRequired);
    if (image) {
      formData.append('image', image);
    }

    await putApi(endPoints.updatesubcategory(id), formData, {
      setLoading,
      successMsg: 'SubCategory updated successfully!',
      errorMsg: 'Failed to update subcategory!',
    });
    SubCategory();
    onHide();
    resetForm();
  };

  const closing = () => {
    resetForm();
    onHide();
  };

  const fetchData = async () => {
    await getApi(endPoints.getallcategory, {
      setResponse: setCategoryData,
      setLoading: setLoading,
      errorMsg: 'Failed to fetch Category!',
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className={modal.modaldownload}>
          <div className={modal.modaldownloadheading}>
            <h6>{props.edit ? 'Edit SubCategory' : 'Add SubCategory'}</h6>
            <IoClose color="#000000" size={25} onClick={closing} />
          </div>
          <div className={modal.modaldownloadinputconatiner}>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="categoryName">Name</label>
              <input
                type="text"
                id="categoryName"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="categoryName">Select Category</label>
              <select
                value={categoryId || ''}
                onChange={e => {
                  const selectedCategory = categoryData?.data?.find(
                    category => category._id === e.target.value
                  );
                  setCategoryId(e.target.value);
                  setCategoryname(selectedCategory?.name || '');
                }}
              >
                <option value="">Select Category</option>
                {categoryData?.data?.map(category => (
                  <option key={category._id} value={category._id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="categoryName">Is Product</label>
              <select
                onChange={e => setIsProduct(e.target.value === 'true')}
                value={isproduct.toString()} // Convert boolean to string
              >
                <option value="">Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="approvalRequired">Approval Required</label>
              <select
                id="approvalRequired"
                onChange={e => setApprovalRequired(e.target.value === 'true')}
                value={approvalRequired.toString()}
              >
                <option value="false">No</option>
                <option value="true">Yes</option>
              </select>
              <p style={{ fontSize: '12px', color: '#8A8A8A', marginTop: '6px' }}>
                Applies to new staff assignments only. Active shifts keep their existing setting.
              </p>
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="categoryImage">Image</label>
              <div className={modal.modalupload} onClick={handleUploadClick}>
                <IoCloudUploadSharp />
                <p>Upload a Image</p>
              </div>
              <input
                type="file"
                id="categoryImage"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
              {imagePreview && (
                <div className={modal.imagePreview}>
                  <img
                    src={imagePreview}
                    alt="Selected"
                    style={{
                      width: '100%',
                      marginTop: '10px',
                      borderRadius: '8px',
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className={modal.modaldownloadbutton}>
            <button onClick={props.edit ? handleupdate : handleSubmit} disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const AddSubCategoryChild = props => {
  const { data, edit, SubCategorychild, onHide } = props;
  const id = data?._id;

  const [name, setName] = useState(data?.name || '');
  const [subcategoryId, setSubCategoryId] = useState(data?.subCategoryId?._id || '');
  const [subcategoryname, setSubCategoryname] = useState(data?.subCategoryId?.name || '');
  const [price, setPrice] = useState(data?.price || '');
  const [staffprice, setStaffPrice] = useState(data?.forStaffPrice || '');
  const [totaltime, setTotalTime] = useState(data?.totalTime || '');
  const [totalmin, setTotalmin] = useState(data?.totalMin || '');
  const [loading, setLoading] = useState(false);
  const [subcategoryData, setSubCategoryData] = useState([]);

  useEffect(() => {
    if (edit && data) {
      setName(data?.name || '');
      setSubCategoryId(data?.subCategoryId?._id || '');
      setSubCategoryname(data?.subCategoryId?.name || '');
      setPrice(data?.price || '');
      setStaffPrice(data?.forStaffPrice || '');
      setTotalTime(data?.totalTime || '');
      setTotalmin(data?.totalMin || '');
    } else if (!edit) {
      resetForm();
    }
  }, [edit, data]);

  const resetForm = () => {
    setName('');
    setSubCategoryId('');
    setSubCategoryname('');
    setPrice('');
    setStaffPrice('');
    setTotalTime('');
    setTotalmin('');
  };

  const handleSubmit = async () => {
    if (!name || !subcategoryId) {
      toast.error('Please provide all required fields!');
      return;
    }

    const payload = {
      name,
      subCategoryId: subcategoryId,
      price: parseFloat(price),
      forStaffPrice: parseFloat(staffprice),
      totalTime: `${totaltime} Hours`,
      totalMin: totaltime * 60,
    };

    await postApi(endPoints.addsubcategorychild, payload, {
      setLoading,
      successMsg: 'SubCategory Child added successfully!',
      errorMsg: 'Failed to add SubCategory Child!',
    });

    SubCategorychild();
    onHide();
    resetForm();
  };

  const handleUpdate = async () => {
    if (!name || !subcategoryId) {
      toast.error('Please provide all required fields!');
      return;
    }

    const payload = {
      name,
      subCategoryId: subcategoryId,
      price: parseFloat(price),
      forStaffPrice: parseFloat(staffprice),
      totalTime: `${totaltime}`,
      totalMin: totaltime * 60,
    };

    await putApi(endPoints.updatesubcategorychild(id), payload, {
      setLoading,
      successMsg: 'SubCategory Child updated successfully!',
      errorMsg: 'Failed to update SubCategory Child!',
    });

    SubCategorychild();
    onHide();
    resetForm();
  };

  const closing = () => {
    resetForm();
    onHide();
  };

  const fetchData = async () => {
    await getApi(endPoints.getallsubcategory, {
      setResponse: setSubCategoryData,
      setLoading,
      errorMsg: 'Failed to fetch SubCategories!',
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className={modal.modaldownload}>
          <div className={modal.modaldownloadheading}>
            <h6>{edit ? 'Edit SubCategory Child' : 'Add SubCategory Child'}</h6>
            <IoClose color="#000000" size={25} onClick={closing} />
          </div>
          <div className={modal.modaldownloadinputconatiner}>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="Enter name"
              />
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="price">User Price</label>
              <input
                type="number"
                id="price"
                value={price}
                onChange={e => setPrice(e.target.value)}
                placeholder="Enter price"
              />
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="price">Staff Price</label>
              <input
                type="number"
                id="staffprice"
                value={staffprice}
                onChange={e => setStaffPrice(e.target.value)}
                placeholder="Enter price"
              />
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="totalTime">Total time in hours</label>
              <input
                type="text"
                id="totalTime"
                value={totaltime}
                onChange={e => setTotalTime(e.target.value)}
                placeholder="Enter total time"
              />
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="subcategory">Select SubCategory</label>
              <select
                value={subcategoryId || ''}
                onChange={e => {
                  const selectedSubCategory = subcategoryData?.data?.find(
                    subcategory => subcategory._id === e.target.value
                  );
                  setSubCategoryId(e.target.value);
                  setSubCategoryname(selectedSubCategory?.name || '');
                }}
              >
                <option value="">Select SubCategory</option>
                {subcategoryData?.data?.map(subcategory => (
                  <option key={subcategory._id} value={subcategory._id}>
                    {subcategory.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className={modal.modaldownloadbutton}>
            <button onClick={edit ? handleUpdate : handleSubmit} disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const AddProduct = props => {
  const { data, edit, product, onHide } = props;
  const id = data?._id;

  const [name, setName] = useState(data?.name || '');
  const [price, setPrice] = useState(data?.price || '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (edit && data) {
      setName(data?.name || '');
      setPrice(data?.price || '');
    } else {
      resetForm();
    }
  }, [edit, data]);

  // Reset form inputs
  const resetForm = () => {
    setName('');
    setPrice('');
  };

  const handleSubmit = async () => {
    if (!name || !price) {
      toast.error('Please provide all the fields!');
      return;
    }

    const payload = {
      name,
      price: parseFloat(price),
    };

    await postApi(endPoints.addproduct, payload, {
      setLoading,
      successMsg: 'Product added successfully!',
      errorMsg: 'Failed to add product!',
    });
    product();
    onHide();
    resetForm();
  };
  const handleUpdate = async () => {
    if (!name) {
      toast.error('Please provide a name!');
      return;
    }
    const payload = {
      name,
      price: parseFloat(price),
    };

    await putApi(endPoints.updateproduct(id), payload, {
      setLoading,
      successMsg: 'Product updated successfully!',
      errorMsg: 'Failed to update product!',
    });
    product();
    onHide();
    resetForm();
  };

  const closing = () => {
    resetForm();
    onHide();
  };

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className={modal.modaldownload}>
          <div className={modal.modaldownloadheading}>
            <h6>{props.edit ? 'Edit Product' : 'Add Product'}</h6>
            <IoClose color="#000000" size={25} onClick={closing} />
          </div>
          <div className={modal.modaldownloadinputconatiner}>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="categoryName">Name</label>
              <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} />
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="price">Price</label>
              <input
                type="number"
                id="price"
                value={price}
                onChange={e => setPrice(e.target.value)}
              />
            </div>
          </div>
          <div className={modal.modaldownloadbutton}>
            <button onClick={edit ? handleUpdate : handleSubmit} disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const UpdateCommissionForUser = props => {
  const { data, Category, onHide, type } = props;

  const [commission, setCommission] = useState(data?.commission || '');
  const [disCountType, setDisCountType] = useState(data?.disCountType || '');
  const [description, setDescription] = useState(data?.description || '');
  const foruser = type;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) {
      setCommission(data?.commission || '');
      setDisCountType(data?.disCountType || '');
      setDescription(data?.description || '');
    } else {
      resetForm();
    }
  }, [data]);

  // Reset form inputs
  const resetForm = () => {
    setCommission('');
    setDisCountType('');
    setDescription('');
  };

  const handleSubmit = async () => {
    const payload = {
      commission,
      disCountType,
      description,
      for: foruser,
    };

    await postApi(endPoints.addcommision, payload, {
      setLoading,
      successMsg: 'Commision added successfully!',
      errorMsg: 'Failed to add commision!',
    });
    Category();
    onHide();
    resetForm();
  };

  const closing = () => {
    resetForm();
    onHide();
  };

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className={modal.modaldownload}>
          <div className={modal.modaldownloadheading}>
            <h6>Edit Commision</h6>
            <IoClose color="#000000" size={25} onClick={closing} />
          </div>
          <div className={modal.modaldownloadinputconatiner}>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="categoryName">Commission</label>
              <input
                type="text"
                id="name"
                value={commission}
                onChange={e => setCommission(e.target.value)}
              />
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="price">Discount Type</label>
              <select onChange={e => setDisCountType(e.target.value)} value={disCountType}>
                <option value="">Select</option>
                <option value="PERCENTAGE">Percentage</option>
                <option value="FLAT">Flat</option>
              </select>
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="categoryName">Description</label>
              <textarea
                placeholder="Enter the description"
                value={description}
                onChange={e => setDescription(e.target.value)}
              />
            </div>
          </div>
          <div className={modal.modaldownloadbutton}>
            <button onClick={handleSubmit} disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const AddTrainingvideos = props => {
  const { data, edit, videos, onHide } = props;
  const id = data?._id;
  const [title, setTitle] = useState(data?.title || '');
  const [video, setVideo] = useState(null);
  const [description, setDescription] = useState(data?.description || '');
  const [videoPreview, setVideoPreview] = useState(data?.video || null);

  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (edit && data) {
      setTitle(data.title || '');
      setVideo(null);
      setDescription(data?.description || '');
      setVideoPreview(data.video || null);
    } else {
      resetForm();
    }
  }, [edit, data]);

  // Reset form inputs
  const resetForm = () => {
    setTitle('');
    setVideo(null);
    setDescription(null);
    setVideoPreview('');
  };

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      setVideo(file);
      setVideoPreview(URL.createObjectURL(file));
    }
  };
  const handleUploadClick = () => fileInputRef.current?.click();

  const handleSubmit = async () => {
    if (!title || !video) {
      toast.error('Please provide both title and video!');
      return;
    }
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('video', video);

    await postApi(endPoints.addvideo, formData, {
      setLoading,
      successMsg: 'Training Video added successfully!',
      errorMsg: 'Failed to add training video!',
    });
    videos();
    onHide();
    resetForm();
  };
  const handleUpdate = async () => {
    if (!title) {
      toast.error('Please provide a title!');
      return;
    }
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    if (video) formData.append('video', video);

    await putApi(endPoints.updateVideos(id), formData, {
      setLoading,
      successMsg: 'Training Video updated successfully!',
      errorMsg: 'Failed to update training video!',
    });
    videos();
    onHide();
    resetForm();
  };

  const closeModal = () => {
    resetForm();
    onHide();
  };

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className={modal.modaldownload}>
          <div className={modal.modaldownloadheading}>
            <h6>{edit ? 'Edit Training Video' : 'Add Training Video'}</h6>
            <IoClose size={25} onClick={closeModal} />
          </div>
          <div className={modal.modaldownloadinputconatiner}>
            <div className={modal.modaldownloadinput}>
              <label>Title</label>
              <input type="text" value={title} onChange={e => setTitle(e.target.value)} />
            </div>
            <div className={modal.modaldownloadinput}>
              <label>Description</label>
              <input
                type="text"
                value={description}
                onChange={e => setDescription(e.target.value)}
              />
            </div>
            <div className={modal.modaldownloadinput}>
              <label>Video</label>
              <div className={modal.modalupload} onClick={handleUploadClick}>
                <IoCloudUploadSharp />
                <p>Upload an Video</p>
              </div>
              <input type="file" ref={fileInputRef} onChange={handleFileChange} hidden />
              {videoPreview && (
                <video src={videoPreview} alt="Preview" className={modal.imagePreview} controls />
              )}
            </div>
          </div>
          <div className={modal.modaldownloadbutton}>
            <button onClick={edit ? handleUpdate : handleSubmit} disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const ViewUserProfile = props => {
  const { data, onHide } = props;

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body style={{ padding: '30px' }}>
        <div className={modal.modelsuccessfullyclose}>
          <RiCloseLargeFill color="#000000" size={25} onClick={onHide} />
        </div>
        <div className={modal.modeluserprofile}>
          <div className={modal.modeluserprofilecontainer}>
            <h6>User Details</h6>
            <div className={modal.adduserleftdetails}>
              <div className={modal.adduserleftprofileimage}>
                <img src={data?.image} alt={data?.firstName} />
              </div>
              <div className={modal.adduserleftuserdetails}>
                <div className={modal.adduserleftuser}>
                  <p>Name</p>
                  <span>:</span>
                  <p>
                    {data?.firstName} {data?.lastName}
                  </p>
                </div>
                <div className={modal.adduserleftuser}>
                  <p>Email</p>
                  <span>:</span>
                  <p>{data?.email}</p>
                </div>
                <div className={modal.adduserleftuser}>
                  <p>Number</p>
                  <span>:</span>
                  <p>+91{data?.phone}</p>
                </div>
                <div className={modal.adduserleftuser}>
                  <p>Gender</p>
                  <span>:</span>
                  <p>{data?.gender}</p>
                </div>
                <div className={modal.adduserleftuser}>
                  <p>Wallet</p>
                  <span>:</span>
                  <p>{data?.wallet ? data?.wallet : '0'}</p>
                </div>
              </div>
            </div>
            {/* <h6>Documents</h6>
                        <div className={modal.adduserrighttdocumentdetails}>
                            <div className={modal.adduserrightdocumentimage}>
                                <div className={modal.adduserrightdocument}>
                                    <img src={data?.addressProof} alt="no img" />
                                </div>
                                <div className={modal.adduserrightdocument}>
                                    <img src={data?.aadharCardFront} alt="no img" />
                                </div>
                                <div className={modal.adduserrightdocument}>
                                    <img src={data?.aadharCardBack} alt="no img" />
                                </div>
                                <div className={modal.adduserrightdocument}>
                                    <img src={data?.panCardLicensePassport} alt="no img" />
                                </div>
                            </div>
                            <div className={modal.adduserleftuserdetails}>
                                <div className={modal.adduserleftuser}>
                                    <p>Description</p>
                                    <span>:</span>
                                    <h5>{data?.description ? data?.description : "N/A"}</h5>
                                </div>
                                <div className={modal.adduserleftuser}>
                                    <p>Status</p>
                                    <span>:</span>
                                    <p>{data?.status ? data?.status : "N/A"}</p>
                                </div>
                            </div>
                        </div> */}
          </div>
          <div className={modal.modeluserprofilebutton}>
            <Link to={`/user-management/userprofile/${data?._id}`}>
              <button>View More</button>
            </Link>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const AddOrderTiming = props => {
  const { data, edit, product, onHide } = props;
  const id = data?._id;

  const [name, setName] = useState(data?.name || '');
  const [price, setPrice] = useState(data?.price || '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (edit && data) {
      setName(data?.name || '');
      setPrice(data?.price || '');
    } else {
      resetForm();
    }
  }, [edit, data]);

  // Reset form inputs
  const resetForm = () => {
    setName('');
    setPrice('');
  };

  const handleSubmit = async () => {
    if (!name || !price) {
      toast.error('Please provide all the fields!');
      return;
    }

    const payload = {
      name,
      price: parseFloat(price),
    };

    await postApi(endPoints.addproduct, payload, {
      setLoading,
      successMsg: 'Product added successfully!',
      errorMsg: 'Failed to add product!',
    });
    product();
    onHide();
    resetForm();
  };
  const handleUpdate = async () => {
    if (!name) {
      toast.error('Please provide a name!');
      return;
    }
    const payload = {
      name,
      price: parseFloat(price),
    };

    await putApi(endPoints.updateproduct(id), payload, {
      setLoading,
      successMsg: 'Product updated successfully!',
      errorMsg: 'Failed to update product!',
    });
    product();
    onHide();
    resetForm();
  };

  const closing = () => {
    resetForm();
    onHide();
  };

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className={modal.modaldownload}>
          <div className={modal.modaldownloadheading}>
            <h6>{props.edit ? 'Edit Product' : 'Add Product'}</h6>
            <IoClose color="#000000" size={25} onClick={closing} />
          </div>
          <div className={modal.modaldownloadinputconatiner}>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="categoryName">Name</label>
              <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} />
            </div>
            <div className={modal.modaldownloadinput}>
              <label htmlFor="price">Price</label>
              <input
                type="number"
                id="price"
                value={price}
                onChange={e => setPrice(e.target.value)}
              />
            </div>
          </div>
          <div className={modal.modaldownloadbutton}>
            <button onClick={edit ? handleUpdate : handleSubmit} disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const AddOutfit = props => {
  const { data, edit, fetchdata, onHide } = props;
  const id = data?._id;
  const [name, setName] = useState(data?.name || '');
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (edit && data) {
      setName(data.name || '');
    } else {
      resetForm();
    }
  }, [edit, data]);

  // Reset form inputs
  const resetForm = () => {
    setName('');
  };

  const handleSubmit = async () => {
    if (!name) {
      toast.error('Please provide name');
      return;
    }
    const payload = {
      name: name,
    };

    await postApi(endPoints.addoutfit, payload, {
      setLoading,
      successMsg: 'Outfit added successfully!',
      errorMsg: 'Failed to add outfit!',
    });
    fetchdata();
    onHide();
    resetForm();
  };
  const handleUpdate = async () => {
    if (!name) {
      toast.error('Please provide a name!');
      return;
    }
    const payload = {
      name: name,
    };

    await putApi(endPoints.updatedoutfitById(id), payload, {
      setLoading,
      successMsg: 'Outfit updated successfully!',
      errorMsg: 'Failed to update outfit!',
    });
    fetchdata();
    onHide();
    resetForm();
  };

  const closeModal = () => {
    resetForm();
    onHide();
  };

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className={modal.modaldownload}>
          <div className={modal.modaldownloadheading}>
            <h6>{edit ? 'Edit Outfit' : 'Add Outfit'}</h6>
            <IoClose size={25} onClick={closeModal} />
          </div>
          <div className={modal.modaldownloadinputconatiner}>
            <div className={modal.modaldownloadinput}>
              <label>Dress Name</label>
              <input type="text" value={name} onChange={e => setName(e.target.value)} />
            </div>
          </div>
          <div className={modal.modaldownloadbutton}>
            <button onClick={edit ? handleUpdate : handleSubmit} disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const CreateOrderchoose = props => {
  const { data, onHide } = props;

  return (
    <Modal {...props} size="sl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className={modal.modalcreateorder}>
          <div className={modal.modaldownloadheading}>
            <h6>Create Order For</h6>
            <IoClose size={25} onClick={onHide} />
          </div>
          <div className={modal.modalcreateordermain}>
            <Link to={`/user-management/create-product/${data}`} style={{ textDecoration: 'none' }}>
              <div className={modal.modalcreateorderleft}>
                <h6>Order Product</h6>
              </div>
            </Link>
            <Link to={`/user-management/create-order/${data}`} style={{ textDecoration: 'none' }}>
              <div className={modal.modalcreateorderleft}>
                <h6>Order Service</h6>
              </div>
            </Link>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export {
  AddCategory,
  AddOutfit,
  AddProduct,
  AddSubCategory,
  AddSubCategoryChild,
  AddTrainingvideos,
  CreateOrderchoose,
  DeleteSuccessfullyModal,
  DownloadModal,
  DownloadTimesheetModal,
  SuccessfullyModal,
  UpdateCommissionForUser,
  ViewStaffProfile,
  ViewUserProfile,
};
